import { sideBarStyles } from "components/Layout/components/SideBar/sideBarStyles";
import styled from "styled-components";

const SideBarStyle = styled.aside`
    ${sideBarStyles}
`;

export const SideBarHTML = styled(SideBarStyle).attrs(() => ({ className: "aevi-side-bar" as string }))``;
